import { render, staticRenderFns } from "./WorkActions.vue?vue&type=template&id=d0d5c082&scoped=true&"
import script from "./WorkActions.vue?vue&type=script&lang=js&"
export * from "./WorkActions.vue?vue&type=script&lang=js&"
import style0 from "./WorkActions.vue?vue&type=style&index=0&id=d0d5c082&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d5c082",
  null
  
)

export default component.exports